module.exports = __webpack_public_path__ + "static/media/RP-39.5c760677.pdf";